import { PaymentMethod } from '@/types';
import { Typography } from 'antd';

interface Props {
  paymentMethod: PaymentMethod | null | undefined;
  subscriptionStatus: 'active' | 'trialing' | 'canceled' | undefined;
}

export default function FranchisePaymentAndSubmissionDetails({
  paymentMethod,
  subscriptionStatus,
}: Props) {
  const statusColors = {
    active: '#1C8271',
    trialing: '#FFA500',
    canceled: '#F68B8B',
  };
  return (
    <div className="details-section-column">
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Subscription
        </Typography.Text>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              backgroundColor: subscriptionStatus
                ? statusColors[subscriptionStatus]
                : 'gray',
            }}
          />
          <Typography.Text className="general-info-value">
            {subscriptionStatus
              ? subscriptionStatus.slice(0, 1).toUpperCase() +
                subscriptionStatus.slice(1)
              : 'Unsubscribed'}
          </Typography.Text>
        </div>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Payment Method
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {paymentMethod ? paymentMethod.stripePaymentMethodType : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Card number
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {paymentMethod ? `**** **** **** ${paymentMethod.last4}` : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Date expiration
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {paymentMethod
            ? `${paymentMethod.expMonth}/${paymentMethod.expYear}`
            : '-'}
        </Typography.Text>
      </div>
    </div>
  );
}
